// Dynamic school prompt loader - only loads the specific school's prompts
// This ensures school-specific evaluation and reduces token usage

import { INSEAD_PROMPTS, INSEAD_INFO } from './schools/insead.js';
import { YALE_SOM_PROMPTS, YALE_SOM_INFO } from './schools/yaleSom.js';

// School lookup mapping
const SCHOOL_MODULES = {
  'INSEAD': INSEAD_PROMPTS,
  'YALE_SOM': YALE_SOM_PROMPTS
};

const SCHOOL_INFO_MODULES = {
  'INSEAD': INSEAD_INFO,
  'YALE_SOM': YALE_SOM_INFO
};

// Helper function to get school-specific evaluation prompt
export const getSchoolPrompt = (schoolName, step = 1) => {
  const school = SCHOOL_MODULES[schoolName];
  if (!school) {
    throw new Error(`School prompt not found for: ${schoolName}. Available schools: ${Object.keys(SCHOOL_MODULES).join(', ')}`);
  }
  
  // Use step-specific prompts when available
  let promptKey;
  switch(step) {
    case 1:
      promptKey = 'step1EvaluationPrompt';
      break;
    case 2:
      promptKey = 'step2EvaluationPrompt';
      break;
    case 3:
      promptKey = 'step3EvaluationPrompt';
      break;
    case 4:
      promptKey = 'step4EvaluationPrompt';
      break;
    default:
      promptKey = 'evaluationPrompt';
  }
  
  const evaluationPrompt = school[promptKey] || school.evaluationPrompt;
  
  if (!evaluationPrompt) {
    throw new Error(`No evaluation prompt found for ${schoolName} step ${step}`);
  }
  
  return `${school.schoolContext}\n\n${evaluationPrompt}`;
};

// School information for display
export const SCHOOL_INFO = {
  INSEAD: INSEAD_INFO,
  YALE_SOM: YALE_SOM_INFO
};

// Export available school names for components
export const AVAILABLE_SCHOOLS = Object.keys(SCHOOL_MODULES); 